/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskSupportedOrgInformation
 */
export interface ExecRiskSupportedOrgInformation {
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskSupportedOrgInformation
     */
    supported_organization_name?: ExecRiskBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskSupportedOrgInformation
     */
    ein?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskSupportedOrgInformation
     */
    organization_type_cd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskSupportedOrgInformation
     */
    governing_document_listed_ind?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskSupportedOrgInformation
     */
    support_amt?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskSupportedOrgInformation
     */
    other_support_amt?: number;
}

/**
 * Check if a given object implements the ExecRiskSupportedOrgInformation interface.
 */
export function instanceOfExecRiskSupportedOrgInformation(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskSupportedOrgInformationFromJSON(json: any): ExecRiskSupportedOrgInformation {
    return ExecRiskSupportedOrgInformationFromJSONTyped(json, false);
}

export function ExecRiskSupportedOrgInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskSupportedOrgInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supported_organization_name': !exists(json, 'supported_organization_name') ? undefined : ExecRiskBusinessNameFromJSON(json['supported_organization_name']),
        'ein': !exists(json, 'ein') ? undefined : json['ein'],
        'organization_type_cd': !exists(json, 'organization_type_cd') ? undefined : json['organization_type_cd'],
        'governing_document_listed_ind': !exists(json, 'governing_document_listed_ind') ? undefined : json['governing_document_listed_ind'],
        'support_amt': !exists(json, 'support_amt') ? undefined : json['support_amt'],
        'other_support_amt': !exists(json, 'other_support_amt') ? undefined : json['other_support_amt'],
    };
}

export function ExecRiskSupportedOrgInformationToJSON(value?: ExecRiskSupportedOrgInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supported_organization_name': ExecRiskBusinessNameToJSON(value.supported_organization_name),
        'ein': value.ein,
        'organization_type_cd': value.organization_type_cd,
        'governing_document_listed_ind': value.governing_document_listed_ind,
        'support_amt': value.support_amt,
        'other_support_amt': value.other_support_amt,
    };
}

